// import Axios from "axios";
import React, { useEffect, useState } from "react";
import { useUnauthenticatedApi } from "../../hooks/useApi";
import { humanizeNumbers } from "../../utils/format";
import CurrencyContext from "./CurrencyContext";

interface CurrencyProviderProps {}

const CurrencyProvider: React.FC<CurrencyProviderProps> = ({ children }) => {
  const [currency, setCurrency] = useState<string>(
    localStorage.getItem("currency") || "INR"
  );
  const [currencySymbol, setCurrencySymbol] = useState<string>("");
  const [allCurrencies, setAllCurrencies] = useState<
    { id: string; value: string; symbol: string }[]
  >([]);
  const [convertedCurrency, setConvertedCurrency] = useState<number>(1);
  const [isDataLoading, setIsDataLoading] = useState<boolean>(true);

  const currenciesApi = useUnauthenticatedApi("PAYMENT_EXCHANGE_CURRENCIES");
  const currencyConvertApi = useUnauthenticatedApi("PAYMENT_EXCHANGE_RATE");

  useEffect(() => {
    if (currenciesApi) {
      currenciesApi.get("").then((res: any) => {
        setAllCurrencies(
          res.data.currencies.map((k: any) => {
            return {
              id: k.code,
              value: `${k.code} - ${k.description}`,
              symbol: k.symbol,
            };
          })
        );
      });
    }
  }, [currenciesApi]);

  useEffect(() => {
    if (currencyConvertApi && currency !== "INR") {
      setIsDataLoading(true);
      currencyConvertApi.get(`?from=INR&to=${currency}`).then((res: any) => {
        setConvertedCurrency(Number(res.data.rate));
        setIsDataLoading(false);
      });
    }
    if (currency === "INR") {
      setConvertedCurrency(1);
      setIsDataLoading(false);
    }
  }, [currency, currencyConvertApi]);

  useEffect(() => {
    const selectedCurrency =
      allCurrencies && allCurrencies.find((k) => k.id === currency);

    setCurrencySymbol(
      selectedCurrency !== undefined ? selectedCurrency.symbol : ""
    );
  }, [allCurrencies, currency]);

  useEffect(() => {
    localStorage.setItem("currency", currency);
  }, [currency]);

  const formatCurrency = (amount: number): string =>
    currency === "INR"
      ? `₹${humanizeNumbers(amount, true)}`
      : `${currencySymbol}${humanizeNumbers(convertedCurrency * amount)} ${
          currencySymbol === "" ? currency : ""
        }`;

  return (
    <CurrencyContext.Provider
      value={{
        currency,
        setCurrency,
        allCurrencies,
        isDataLoading,
        formatCurrency,
      }}
    >
      {children}
    </CurrencyContext.Provider>
  );
};

export default CurrencyProvider;
